import { render } from "./OrderGenerateInvoiceButton.vue?vue&type=template&id=0ca55f46"
import script from "./OrderGenerateInvoiceButton.vue?vue&type=script&lang=js"
export * from "./OrderGenerateInvoiceButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__